module.exports = __webpack_public_path__ + "img/N121-2.4ec82ab2.png";